var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 217.61 64.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#5bc9f4;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 50.19,
    y1: 32.21,
    x2: 11.3,
    y2: 32.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fbbc0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#faa418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99b1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 40.1,
    y1: 35.9,
    x2: 3.53,
    y2: 72.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef4547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6186d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3.36,
    y1: -8.21,
    x2: 33.22,
    y2: 21.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#279e6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2ba06f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#53b26c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6bbd6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74c169"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google_Play",
    "data-name": "Google Play"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.81,
    y: 0.81,
    width: 216,
    height: 62.44,
    rx: 7.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.43,64.05H8.19A8.19,8.19,0,0,1,0,55.86V8.19A8.19,8.19,0,0,1,8.19,0H209.43a8.19,8.19,0,0,1,8.18,8.19V55.86A8.19,8.19,0,0,1,209.43,64.05ZM8.19,1.62A6.57,6.57,0,0,0,1.62,8.19V55.86a6.58,6.58,0,0,0,6.57,6.58H209.43A6.58,6.58,0,0,0,216,55.86V8.19a6.57,6.57,0,0,0-6.57-6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.78,35a6.84,6.84,0,1,0,6.86,6.84A6.74,6.74,0,0,0,109.78,35Zm0,11a4.16,4.16,0,1,1,3.86-4.15A4,4,0,0,1,109.78,46Zm-15-11a6.84,6.84,0,1,0,6.86,6.84A6.74,6.74,0,0,0,94.8,35Zm0,11a4.16,4.16,0,1,1,3.86-4.15A4,4,0,0,1,94.8,46ZM77,37.13V40h6.94a6.06,6.06,0,0,1-1.58,3.65A7.11,7.11,0,0,1,77,45.81a7.72,7.72,0,0,1,0-15.44,7.38,7.38,0,0,1,5.23,2.07l2.05-2A10.12,10.12,0,0,0,77,27.46a10.63,10.63,0,1,0,0,21.25,9.73,9.73,0,0,0,7.41-3,9.58,9.58,0,0,0,2.51-6.79,9.8,9.8,0,0,0-.15-1.81Zm72.87,2.25A6.36,6.36,0,0,0,144,35a6.5,6.5,0,0,0-6.45,6.84,6.7,6.7,0,0,0,6.79,6.84,6.8,6.8,0,0,0,5.7-3l-2.33-1.56a3.92,3.92,0,0,1-3.37,1.9A3.48,3.48,0,0,1,141,43.94l9.15-3.78Zm-9.33,2.28a3.75,3.75,0,0,1,3.58-4,2.66,2.66,0,0,1,2.54,1.45Zm-7.43,6.64h3V28.19h-3Zm-4.93-11.74h-.1a4.73,4.73,0,0,0-3.6-1.53,6.85,6.85,0,0,0,0,13.68,4.67,4.67,0,0,0,3.6-1.55h.1v1c0,2.62-1.4,4-3.65,4a3.79,3.79,0,0,1-3.45-2.44l-2.61,1.09a6.51,6.51,0,0,0,6.06,4c3.52,0,6.5-2.07,6.5-7.12V35.44h-2.85ZM124.72,46a3.92,3.92,0,0,1-3.81-4.12,4,4,0,0,1,3.81-4.18c2,0,3.65,1.77,3.65,4.18A3.83,3.83,0,0,1,124.72,46Zm39.21-17.83h-7.19V48.3h3V40.68h4.19a6.25,6.25,0,1,0,0-12.49Zm.08,9.69h-4.27V31H164a3.45,3.45,0,1,1,0,6.89ZM182.55,35a5.63,5.63,0,0,0-5.35,3.08l2.66,1.11a2.85,2.85,0,0,1,2.75-1.47c1.55,0,3.13.93,3.15,2.59v.2a6.62,6.62,0,0,0-3.13-.77c-2.87,0-5.79,1.57-5.79,4.52,0,2.69,2.35,4.43,5,4.43a4.24,4.24,0,0,0,3.83-2h.1v1.55h2.9V40.55C188.66,37,186,35,182.55,35Zm-.36,11c-1,0-2.35-.49-2.35-1.71,0-1.55,1.71-2.14,3.18-2.14a5.31,5.31,0,0,1,2.74.67A3.63,3.63,0,0,1,182.19,46Zm17-10.58-3.44,8.72h-.1l-3.57-8.72h-3.23l5.35,12.19-3.05,6.77h3.13l8.25-19Zm-27,12.87h3V28.19h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,12.18a3.23,3.23,0,0,0-.74,2.26V50A3.19,3.19,0,0,0,17,52.24l.12.12L37,32.45V32L17.09,12.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.64,39.09,37,32.45V32l6.64-6.64.15.08,7.86,4.47c2.25,1.28,2.25,3.37,0,4.64L43.79,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.79,39,37,32.21l-20,20c.74.78,2,.88,3.34.1L43.79,39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.79,25.42,20.31,12.08c-1.38-.78-2.6-.68-3.34.1l20,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.93,13.32a3.5,3.5,0,0,0-2.28-.88,3.56,3.56,0,0,0-3.51,3.64,3.54,3.54,0,0,0,3.51,3.63,2.75,2.75,0,0,0,3-2.56H72V16h4.14c0,3.32-1.77,4.89-4.47,4.89a4.86,4.86,0,0,1,0-9.71,4.68,4.68,0,0,1,3.2,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.47,11.33v1.19H79.15v3h3.77v1.2H79.15V19.6h4.46v1.19H77.87V11.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.75,11.33v1.21H88.88v8.25H87.59V12.54H84.72V11.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.88,11.33v9.46H96.6V11.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.59,11.33v1.21h-2.87v8.25h-1.29V12.54H99.56V11.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.6,11.22a4.86,4.86,0,1,1-4.78,4.86A4.8,4.8,0,0,1,115.6,11.22Zm0,8.47a3.52,3.52,0,0,0,3.51-3.61,3.51,3.51,0,1,0-7,0A3.52,3.52,0,0,0,115.6,19.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,20.79l-4.31-7.13v7.13h-1.28V11.33h1.26l4.27,7.07V11.33h1.28v9.46Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.a274f26b1b88cae70c1d7e444a173cb3.svg";
export { ForwardRef as ReactComponent };